import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AppService } from 'src/app/core/services/app.service';
import { CustomerService } from 'src/app/core/services/customer.service';
import { SubscriptionItemService } from 'src/app/core/services/subscription-item.service';
import { OOVenueService } from 'src/app/core/services/venue-service';
import { CustomerSubscriptionItem } from 'src/app/shared/models/CustomerSubscription.item';
import { AppMessageSeverity } from 'src/app/shared/models/enums/AppMessageSeverity.enum';
import { OOCanvasMenuItem } from 'src/app/shared/models/oo-canvas-menu-item.model';

@Component({
	selector: 'app-subscription-menu-item-selected',
	templateUrl: './subscription-menu-item-selected.component.html',
	styleUrls: ['./subscription-menu-item-selected.component.scss'],
})
export class SubscriptionMenuItemSelectedComponent implements OnInit {
	@Input() selectedItem: OOCanvasMenuItem;
	@Output() selectedItemChange = new EventEmitter<OOCanvasMenuItem>();

	timestamp = new Date().valueOf();

	selectedFrequency: number;
	selectedItemFrequencies: {
		label: string;
		value: number;
	}[] = [];

	constructor(
		public app: AppService,
		public venueService: OOVenueService,
		public customerService: CustomerService,
		private subscriptionItemService: SubscriptionItemService
	) {}

	ngOnInit(): void {
		this.selectedItem.subscriptionAllowedFrequencies.forEach((freq) => {
			this.selectedItemFrequencies.push({
				label: this.venueService.subscriptionFrequencyToFrequencyDisplayName(freq),
				value: freq,
			});
		});

		if (this.selectedItem.subscriptionAllowedFrequencies.length === 1) {
			this.selectedFrequency = this.selectedItem.subscriptionAllowedFrequencies[0];
		}
	}

	onAddToOrder() {
		this.subscriptionItemService.cartItems.value.push(
			new CustomerSubscriptionItem({
				pk: this.venueService.venueKey.toString(),
				sk: `SI_${this.app.uuidv4()}`,
				menuItemKey: this.selectedItem.menuItemKey,
				priceNumber: this.selectedItem.priceNumber,
				price: this.venueService.menuItemGetPriceFromNumber(this.selectedItem.ooMenuItem, this.selectedItem.priceNumber),
				frequency: this.selectedFrequency,
				addDate: this.app.moment().format(),
				ooMenuItem: this.selectedItem.ooMenuItem,
			})
		);
		this.app.msgSvc.add({
			severity: AppMessageSeverity.GREEN,
			summary: '',
			detail: `${this.venueService.subscriptionFrequencyToFrequencyDisplayName(this.selectedFrequency)} subscription for ${
				this.selectedItem.displayName || this.selectedItem.ooMenuItem.name
			} has been added to your cart`,
		});

		this.selectedItemChange.emit(undefined);
	}
}
